import {Conversation} from '@stripe-internal/conversations-client';
import {FeedbackButtons} from '../Chat/FeedbackButtons';

/**
 * This is for the feedback v2 with thumbs up/down non-blocking feedback project.
 * @see https://home.corp.stripe.com/compass/projects/thumbs-up-thumbs-down-on-universal-help
 */
export const FeedbackContainer = ({
  feedback,
  responseId,
  conversation,
}: {
  conversation: Conversation;
  responseId: string;
  feedback: 'thumbs_up' | 'thumbs_down' | 'none';
}) => {
  return (
    <FeedbackButtons
      onThumbsUp={() =>
        conversation.sendFeedback({
          responseId,
          feedback: feedback === 'thumbs_up' ? 'none' : 'thumbs_up',
        })
      }
      onThumbsDown={() =>
        conversation.sendFeedback({
          responseId,
          feedback: feedback === 'thumbs_down' ? 'none' : 'thumbs_down',
        })
      }
      value={feedback}
    />
  );
};
